<template src="../templates/normal_fcont_150.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadCardPrint from '../components/AppDownloadCardPrint'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '150',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    ReleaseDateForArticle,AppDownloadiPrint,AppDownloadSmartPanel,AppDownloadCreative,
    AppDownloadCardPrint
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['150-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['150-3']}
      ]
    };
  }
  
};
</script>

